import { injectable } from 'tsyringe';
import { authenticatedFetch } from '@/shared/auth/AuthenticatedFetch';

export type HealthLevel = 'ok' | 'warn' | 'critical';

export interface AccountHealthRow {
    tenantId: string;
    name: string;
    status: string;
    planName: string | null;
    entitlementStatus: string | null;
    seatsConsumed: number;
    seatCap: number | null;
    seatUtilization: number | null;
    activeUsers: number;
    health: HealthLevel;
    flags: string[];
}

/**
 * Reads the cross-tenant account-health view (SAAS-33) from the operator-gated
 * billing surface. Aggregation (tenant fan-out) happens server-side.
 */
@injectable()
export class OperatorHealthService {
    async listAccountHealth(): Promise<AccountHealthRow[]> {
        const res = await authenticatedFetch('/_billing/api/operator/billing/account-health');
        if (!res.ok) {
            let message = `Failed to load account health (${res.status})`;
            try {
                const body = (await res.json()) as { error?: string };
                if (body.error) message = body.error;
            } catch { /* keep default */ }
            throw new Error(message);
        }
        return (await res.json()) as AccountHealthRow[];
    }
}
